import Body from './Components/Body'
import Header from './Components/Header'
import Hero from './Components/Hero'
import Firepit from './Components/Firepit'
import Roadmap from './Components/Roadmap'
import Team from './Components/Team'
import NftCards from './Components/NftCards'
import Faq from './Components/Faq'
import Footer from './Components/Footer'
import ElementorWrap from './Components/ElementorWrap'
import Countdown from './Components/Countdown'

function App() {
	const startDate = new Date().getTime() + 604800000 / 1 // initialize year

	return (
		<Body>
			<Header />
			<Hero />
			{/* date to count down in year / month /day format*/}
			<Countdown />
			<ElementorWrap>
				<NftCards />
			</ElementorWrap>
			<Firepit />
			<Roadmap />
			<Team />
			<ElementorWrap>
				<Faq />
			</ElementorWrap>
			<Footer />
		</Body>
	)
}

export default App
